import { Content } from '../../../Models/Content';

export const ContentsReducerName = 'contents';

export type ContentsState = {
  [key: string]: IViewContentsState;
};

export interface IViewContentsState {
  contents: Content[];
  isLoading: boolean;
  errorMessage: string | null;
}
